import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class LocaleModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (LocaleModel._instance == null) LocaleModel._instance = new LocaleModel(authManager);
        return LocaleModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/locales', 'core/locales/codelist');

        this.entityName = 'core.Locale';
        this.privileges = {
            create: [["adminSystem"]],
            read: [["#everyone"]],
            update: [["adminSystem"]],
            delete: [["adminSystem"]],
        };

        this.label = 'Locale';
        this.setLabel = 'Locales';

        this.browser = {
            name: 'default-core-locale-browser',
            moduleName: 'default-core-locale-browser',
            moduleTitle: 'Locales',
            moduleStateSlotName: 'default-core-locale-browser',
        };

        this.editor = {
            name: 'default-core-locale-editor',
            moduleName: 'default-core-locale-editor',
            moduleTitle: 'Locale',
            moduleStateSlotName: 'default-core-locale-editor',
        };

        this.fieldDefs = [
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                primaryKey: true,
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
